<template>
  <div class="container select-age">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Please select your gender</h1>
        </div>
        <div class="title-divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            We need a few details about your age to be able to present you
            correct test results.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="age-wrapper">
          <a @click.prevent="selectAge('< 30')" href="" class="button-main">< 30</a>
          <a @click.prevent="selectAge('30 - 44')" href="" class="button-main">30 - 44</a>
          <a @click.prevent="selectAge('45 - 54')" href="" class="button-main">45 - 54</a>
          <a @click.prevent="selectAge('55 - 64')" href="" class="button-main">55 - 64</a>
          <a @click.prevent="selectAge('65 - 74')" href="" class="button-main">65 - 74</a>
          <a @click.prevent="selectAge('75 +')" href="" class="button-main">75 +</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      selectAge(age) {
        this.$store.commit('setAge', age)
        this.$router.push('/select-source')
      }
    }
  }
</script>
